import React from "react";
import { useShoppingContext } from "../../../../context/ShoppingContext";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMinus, faPlus } from "@fortawesome/free-solid-svg-icons";
import AddAlimentoForm from "../../Forms/AddAlimentoForm/AddAlimentoForm";

const AddAlimento = () => {
  const { setShowAddAlimento, showAddAlimento } =
    useShoppingContext();
  return (
    <div className="AddAlimento">
      {" "}
      {showAddAlimento && <AddAlimentoForm />}
      <button
        className={"btn-show btn-green"}
        onClick={() => setShowAddAlimento(!showAddAlimento)}
      >
        {!showAddAlimento ? `Nuevo Alimento` : ``}{" "}
        <FontAwesomeIcon icon={!showAddAlimento ? faPlus : faMinus} />
      </button>
    </div>
  );
};

export default AddAlimento;
